import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'common/drawers/billingAddressDrawer/CLOSE',
  OPEN_ERROR: 'common/drawers/billingAddressDrawer/OPEN_ERROR',
  OPEN_REQUEST: 'common/drawers/billingAddressDrawer/OPEN_REQUEST',
  OPEN_SUCCESS: 'common/drawers/billingAddressDrawer/OPEN_SUCCESS',
  SAVE_ERROR: 'common/drawers/billingAddressDrawer/SAVE_ERROR',
  SAVE_REQUEST: 'common/drawers/billingAddressDrawer/SAVE_REQUEST',
  SAVE_SUCCESS: 'common/drawers/billingAddressDrawer/SAVE_SUCCESS',
  SET_BILLING_ADDRESS:
    'common/drawers/billingAddressDrawer/SET_BILLING_ADDRESS',
};

export const billingAddressDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  setBillingAddress: ({ billingAddress }) => ({
    type: types.SET_BILLING_ADDRESS,
    payload: { billingAddress },
  }),
};

export const open = {
  error: notify(
    (error) => ({
      type: types.OPEN_ERROR,
      payload: error,
    }),
    'Failed to edit billing address',
  ),
  request: ({ accountId, billingAddressId, callBack, mode }) => ({
    type: types.OPEN_REQUEST,
    payload: {
      accountId,
      billingAddressId,
      callBack,
      mode,
    },
  }),
  success: () => ({
    type: types.OPEN_SUCCESS,
  }),
};

export const save = {
  error: notify(
    (error) => ({
      type: types.SAVE_ERROR,
      payload: error,
    }),
    'Failed to save billing address',
  ),
  request: ({ address1, address2, city, country, postalCode, state }) => ({
    type: types.SAVE_REQUEST,
    payload: { address1, address2, city, country, postalCode, state },
  }),
  success: ({ billingAddressId, billingAddress }) => ({
    type: types.SAVE_SUCCESS,
    payload: { billingAddressId, billingAddress },
  }),
};
